<template>
  <div>
    <div>
      <span class="xbed-sub-title">{{topTitle}}</span>
    </div>
    <div class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>营销管理</BreadcrumbItem>
        <BreadcrumbItem>优惠券管理</BreadcrumbItem>
        <BreadcrumbItem>{{topTitle}}</BreadcrumbItem>
      </Breadcrumb>
    </div>
    <br>
    <Form  @submit.native.prevent="preventSubmit" :rules='editViewRules' ref='editViewForm' class="edit-display">
      <FormItem label='优惠券ID' :label-width="150" v-if="addEditParams.id">
        <span>{{cardId}}</span>
      </FormItem>
      <FormItem v-if="addEditParams.id" :label-width="83">
        <Button type="primary" :loading="addLoading" @click="editInfo" style="width:115px;">{{editable ? '保存' : '编辑'}}</Button>                
      </FormItem>
      <FormItem label='优惠券名' prop="title" :label-width="150">
        <Input type="text" :disabled="!editable" v-model.trim="addEditParams.title" :maxlength="100" style="width: 600px"></Input>
      </FormItem>
      <FormItem label='对客简介' prop="description" :label-width="150">
        <Input type="textarea" :disabled="!editable" v-model.trim="addEditParams.description" :maxlength="2000" :autosize="{minRows:3,maxRows:5}" style="width: 600px"></Input>
      </FormItem>
      <FormItem label='时效类型' :label-width="150">
        <RadioGroup v-model="addEditParams.type">
          <Radio :label="1" :disabled="addEditParams.id != ''" style="width: 150px;margin-left:8px;">固定时间</Radio>
          <Radio :label="2" :disabled="addEditParams.id != ''">领取后计时</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label='固定时间' v-if="addEditParams.type == 1" prop='fixedTime' :label-width="150">
        <DatePicker type="daterange" :disabled="!editable" :editable="false" :readonly="!editable" v-model="fixedTime" format="yyyy-MM-dd HH:mm" @on-change="changeDate" placeholder="请选择优惠券有效日期" style="width: 300px"></DatePicker>
      </FormItem>
      <FormItem label='有效时长' v-if="addEditParams.type == 2" prop="fixedTime" :label-width="150">
        <InputNumber type="text" :disabled="!editable" v-model="addEditParams.fixedTerm" :min="1" :max="999" :step="1" style="width: 300px"></InputNumber>&nbsp;&nbsp;天
      </FormItem>
      <FormItem label='优惠成本' :label-width="150">
        <RadioGroup v-model="addEditParams.bearParty">
          <Radio :label="2" :disabled="addEditParams.id != ''" style="width: 150px;margin-left:8px;">业主承担</Radio>
          <Radio :label="1" :disabled="addEditParams.id != ''">Xbed承担</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label='优惠类型' :label-width="150">
        <Select v-model="addEditParams.couponCardType" :disabled="addEditParams.id != ''" style="width:300px">
          <Option :value="2">代金券</Option>
          <Option :value="3">折扣券</Option>
          <Option :value="1">兑换券</Option>
        </Select>
      </FormItem>
      <FormItem label='减免额' v-if="addEditParams.couponCardType === 2" prop='discountPrice' :label-width='150' class="activity-reward">
        <div class="input-unit">原价满
          <InputNumber type='text' :min="0.01" :max="999999.99" :step="1" :disabled="addEditParams.id != ''" class="input" v-model="addEditParams.leastCost"></InputNumber>
          <span class="unit">元</span>
        </div>
        <div class="input-unit">减
          <InputNumber type='text' :min="0.01" :max="999999.99" :step="1" :disabled="addEditParams.id != ''" class="input" v-model="addEditParams.reduceCost"></InputNumber>
          <span class="unit">元</span>
        </div>
      </FormItem>
      <FormItem label='折扣额' v-if="addEditParams.couponCardType === 3" prop='discountPrice' :label-width='150' class="activity-reward">
        <div class="input-unit">原价满
          <InputNumber type='text' :min="0.01" :max="999999.99" :step="1" :disabled="addEditParams.id != ''" class="input" v-model="addEditParams.leastCost"></InputNumber>
          <span class="unit">元</span>
        </div>
        <div class="input-unit">享
          <InputNumber type='text':min="0.1" :max="10" :step="1" :disabled="addEditParams.id != ''" class="input" v-model="addEditParams.discount"></InputNumber>
          <span class="unit">折</span>
        </div>
        <div class="input-unit">最高减
          <InputNumber type='text' :min="0.01" :max="999999.99" :step="1" :disabled="addEditParams.id != ''" class="input" v-model="addEditParams.maxCost"></InputNumber>
          <span class="unit">元</span>
        </div>
      </FormItem>
      <FormItem label='兑换额' v-if="addEditParams.couponCardType === 1" prop='discountPrice' :label-width='150' class="activity-reward">
        <div class="input-unit">原价满
          <InputNumber type='text' :min="0.01" :max="999999.99" :step="1" :disabled="addEditParams.id != ''" class="input" v-model="addEditParams.leastCost"></InputNumber>
          <span class="unit">元</span>
        </div>
        <div class="input-unit">减房费
          <InputNumber type='text' :min="1" :max="999" :step="1" :disabled="addEditParams.id != ''" class="input" v-model="addEditParams.exchangeNumber"></InputNumber>
          <span class="unit">晚</span>
        </div>
        <div class="input-unit">最高减
          <InputNumber type='text' :min="0.01" :max="999999.99" :step="1" :disabled="addEditParams.id != ''" class="input" v-model="addEditParams.maxCost"></InputNumber>
          <span class="unit">元</span>
        </div>
      </FormItem>
      <FormItem :label-width='160' style="margin-top: -5px;">
        <span style="color: red">{{promoTips[addEditParams.couponCardType]}}</span>
      </FormItem>
      <FormItem label='参与产品' :label-width="150">
        <span class="ivu-form-item-label" style="width:182px;text-align:left;margin-left:8px;margin-right:30px;">{{prodText}}</span>
        <Button type="primary" :disabled="!editable" @click="settingPops('productionSetting')">设置条件</Button>
      </FormItem>
      <FormItem label='参与订单' :label-width="150">
        <span class="ivu-form-item-label" style="width:182px;text-align:left;margin-left:8px;margin-right:30px;">{{orderText}}</span>
        <Button type="primary" :disabled="!editable" @click="settingPops('orderSetting')">设置条件</Button>
      </FormItem>
      <FormItem label='总库存' prop="totalQuantity" :label-width="150">
        <InputNumber v-if="editable && !addEditParams.id" type="text" v-model="addEditParams.totalQuantity" :min="1" :max="99999999" :step="1" style="width: 300px"></InputNumber>
        <span v-if="addEditParams.id" style="display:inline-block;width:182px;margin-left:8px;margin-right:26px;">{{quantity.cacheQuantity}}</span>
        <Button v-if="addEditParams.id != ''" :disabled="!editable" type="primary" @click="settingPops('quantitySetting')">调整库存</Button>
      </FormItem>
      <FormItem label='领取方式' :label-width="150">
        <Select :disabled="addEditParams.id != ''" v-model="addEditParams.collectType" style="width:300px">
          <Option :value="1">输入券码领取</Option>
          <Option :value="2">系统自动下发</Option>
        </Select>
      </FormItem>
      <FormItem label='最后领取日' prop='latestCollectDate' :label-width="150">
        <DatePicker type="date" :disabled="!editable" :readonly="!editable" :options="dateOptions" :editable="false" :clearable="false" v-model="addEditParams.latestCollectDate" format="yyyy-MM-dd" style="width: 300px"></DatePicker>
      </FormItem>
      <FormItem label='券码类型' v-if="addEditParams.collectType === 1" :label-width="150">
        <Select :disabled="addEditParams.id != ''" v-model="addEditParams.promoCodeType" style="width:300px">
          <Option :value="2">通用码</Option>
          <Option :value="1">一卡一码</Option>
        </Select>
      </FormItem>
      <FormItem label='通用码' v-if="addEditParams.collectType === 1 && addEditParams.promoCodeType === 2" prop="promoCode" :label-width="150">
        <Input type="text" :disabled="addEditParams.id != ''" v-model.trim="addEditParams.promoCode" style="width: 300px"></Input>
        <span v-if="!addEditParams.id" style="color: red;display:block;">用户输入通用码领取优惠券，每个账号限领1次</span>
      </FormItem>
      <FormItem :label-width="83" v-if="!addEditParams.id">
        <Button type="primary" :loading="addLoading" @click="saveInfo" style="width:115px;">确认新建</Button>                
      </FormItem>
    </Form>

    <!-- 参与产品弹窗 -->
    <Modal ref="prodModal" v-model="productionSetting" title="参与产品" :loading="true" @on-cancel="cancelModal('resetChain', 'productionForm')" @on-ok="handleProdOk">
      <Form :rules='editViewRules' ref='productionForm' :model="selChainParam">
        <FormItem>
          <RadioGroup v-model="addEditParams.productRestrictType" @on-change="changeProRadio">
            <Radio :label="0" style="width: 150px;">无限制</Radio>
            <Radio :label="1" style="width: 150px;">参与城市</Radio>
            <Radio :label="2">参与门店</Radio>
          </RadioGroup>
        </FormItem>
        <!-- 选择城市 -->
        <FormItem v-if="addEditParams.productRestrictType === 1" prop="selCityId" label='选择城市' :label-width="68">
          <Select ref="resetCity" v-model="selCityParam.selCityId" clearable filterable placeholder="输入下拉选择" @on-change="selectCity" style="width:343px;margin-right: 10px;">
            <Option v-for="(item, index) in allCities" :value="item" :key="index">{{ item }}</Option>
          </Select>
          <Button type="primary" @click="addCities">添加</Button>
        </FormItem>
        <div v-if="addEditParams.productRestrictType === 1" class="sel-tag" style="margin-bottom:32px;">
          <Tag class="tags" v-for="(item, index) in prodLimit.city" :key="index" :name="index" closable @on-close="deleteCity">{{ item }}</Tag>
        </div>
        <!-- 选择门店 -->
        <FormItem prop="selChainId" :label='addEditParams.productRestrictType === 2 ? "选择门店" : "剔除门店"' :label-width="68">
          <Select ref="resetChain" v-model="selChainParam.selChainId" clearable filterable placeholder="id/名称 输入下拉选择" @on-change="selectChain" style="width:343px;margin-right: 10px;">
            <Option v-for="(item, index) in allChains" :value="item.chainId" :key="index">{{ `${item.chainId}_${item.chainName}` }}</Option>
          </Select>
          <Button type="primary" @click="addChains">添加</Button>
        </FormItem>
      </Form>
      <Content>
        <Table :columns="columns" :data="chainParams.selChainsArr" style="width:480px;max-height:281px;overflow-y:auto;"></Table>
        <div style="margin-top: 10px;overflow: hidden">
          <Page 
            size="small"
            show-total
            :total="chainParams.chainCount" 
            :current="chainParams.pageNum" 
            :page-size="5"
            @on-change="changePage"
          >
          </Page>
        </div>
      </Content>
    </Modal>
    <!-- 参与订单弹窗 -->
    <Modal ref="orderModal" v-model="orderSetting" title="参与订单" :loading="true" @on-cancel="cancelOrderModal" @on-ok="handleOrderOk">
      <Form :rules='editViewRules' ref="orderForm" :model="orderLimit">
        <FormItem>
          <RadioGroup v-model="addEditParams.orderRestrictType">
            <Radio :label="0" style="width: 150px;">无限制</Radio>
            <Radio :label="1">参与入住房晚</Radio>
          </RadioGroup>
        </FormItem>
        <div v-show="addEditParams.orderRestrictType === 1">
          <FormItem prop="joinDate" label='可用房晚范围' :label-width="108">
            <DatePicker type="daterange" :editable="false" v-model="orderLimit.joinDate" @on-change="changeJoinDate" format="yyyy-MM-dd" placeholder="请选择可用的房晚日期" style="width: 312px"></DatePicker>
          </FormItem>
          <FormItem prop="week" label='适用星期' :label-width="108">
            <CheckboxGroup v-model="orderLimit.week">
                <Checkbox label="1">一</Checkbox>
                <Checkbox label="2">二</Checkbox>
                <Checkbox label="3">三</Checkbox>
                <Checkbox label="4">四</Checkbox>
                <Checkbox label="5">五</Checkbox>
                <Checkbox label="6">六</Checkbox>
                <Checkbox label="0">日</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label='不参与房晚' :label-width="108" style="margin-bottom:10px;">
            <Button @click="addNoJoinRoom" style="width:115px;">+添加设置</Button>   
          </FormItem>
          <FormItem :label-width="108">
            <div v-for="(item, index) in orderLimit.noJoinDate" :key="index" style="position:relative; margin-bottom: 10px;">
              <DatePicker type="daterange" :editable="false" :clearable="false" v-model="item.date" @on-change="changeNoJoinDate(index)" format="yyyy-MM-dd" placeholder="单选日期/日期段" style="width: 312px"></DatePicker>
              <Icon type="ios-close" @click="deleteDate(index)" size="25" style="margin-left: 5px;position: absolute;top: 5px; color: red; cursor: pointer;"></Icon>
            </div>
          </FormItem>
        </div>
      </Form>
    </Modal>
    <!-- 调整库存弹窗 -->
    <Modal ref="quantityModal" v-model="quantitySetting" title="调整库存" :loading="true" @on-ok="handleQuantityOk" @on-cancel="() => this.$refs.quantityForm.resetFields()">
      <Form ref="quantityForm" :rules='editViewRules' :model="quantity">
        <FormItem label="已领取 / 总库存：" :label-width="150">
          <span>{{addEditParams.quantity}} / {{addEditParams.totalQuantity}}</span>
        </FormItem>
        <FormItem label='调整总库存为：' prop="totalInventory" :label-width="150">
          <InputNumber type="text" :min="1" :max="quantity.maxQuantity" :step="1" v-model="quantity.totalInventory" style="width: 300px"></InputNumber>
        </FormItem>
        <FormItem :label-width="150">
          <p style="color:red;line-height: 20px;">* 一卡一码新库存不得低于原库存</p>
          <p style="color:red;line-height: 20px;">* 其它类型新库存不得低于已领取数量</p>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
/* eslint-disable */
import API from "@/api";
import Utils from "../../utils";
import {numRegExp, blankRegExp} from "@/utils/regular"
import Moment from "moment";
export default {
 created() {
    this.addEditParams.id = localStorage.getItem("promoCode") || ''
    this.token = Utils.findFromLocalStorage( "vue-token" );
		this.userid = Utils.findFromLocalStorage( "vue-userid" );
		this.username = Utils.findFromLocalStorage( "vue-username" );
		this.env = Utils.findFromLocalStorage( "env", "dev" );
    
    // 阿里云接口，header 传参（只有开发环境和测试环境需要传 group）
    this.protHeaders = {
      'x-ca-stage': Utils.aliHeaderEnv(this.env), 
      'Authorization': Utils.findFromLocalStorage("Author-token"),
      // 'Secret': '58dbac0cb9a1db115a473199f8d312e6', // 本地请求 IP 域名才需要传 secret
      // 'Content-Type': 'application/json;charset=UTF-8'
    }
	},
  data () {
    const validateAtity = {
      title: (rule,value,callback) =>{
        if (!this.addEditParams.title) {
          callback(new Error('优惠券名不能为空'))
        }else{
          if (blankRegExp.test(this.addEditParams.title)) {
            callback(new Error('优惠券名不可使用空格'))
          }else{
            callback()
          }
        }
      },
      description: (rule,value,callback) =>{
        if (!this.addEditParams.description) {
          callback(new Error('对客简介不能为空'))
        }else{
          callback()
        }
      },
      fixedTime: (rule,value,callback) =>{
        if ((this.addEditParams.type == 1 && this.fixedTime && !this.fixedTime[0]) || (this.addEditParams.type == 2 && !this.addEditParams.fixedTerm)) {
          let text = this.addEditParams.type == 1 ? '请选择优惠券有效日期' : '请填写有效时长'
          callback(new Error(text))
        }else{
          callback()
        }
      },
      selChainId: (rule,value,callback) =>{
        if (this.clickAddChain && !this.selChainParam.selChainId && !this.prodLimit.chains.length) {
          callback(new Error('请选择门店'))
        } else {
          if (this.clickAddChain && this.prodLimit.chains.length) {
            for (let value of this.prodLimit.chains) {
              if (value.chainId === this.selChainOption.chainId) {
                callback(new Error('该门店已添加，请重新选择'))
                return
              }
            }
          }
          callback()
        }
      },
      selCityId: (rule,value,callback) => {
        if (this.clickAddCity && !this.selCityParam.selCityId && !this.prodLimit.city.length) {
          callback(new Error('请选择城市'))
        } else {
          if (this.clickAddCity && this.prodLimit.city.length) {
            for (let value of this.prodLimit.city) {
              if (value === this.selCityParam.selCityId) {
                callback(new Error('该城市已添加，请重新选择'))
                return
              }
            }
          }
          callback()
        }
      },
      joinDate: (rule,value,callback) =>{
        if (this.addEditParams.orderRestrictType && this.orderLimit.joinDate && !this.orderLimit.joinDate[0]) {
          callback(new Error('请选择可用的房晚日期'))
        }else{
          callback()
        }
      },
      week: (rule,value,callback) =>{
        if (this.addEditParams.orderRestrictType && !this.orderLimit.week.length) {
          callback(new Error('至少勾选一个'))
        }else{
          callback()
        }
      },
      discountPrice:(rule,value,callback) =>{
        let params = this.addEditParams
        if (!params.leastCost || 
          (params.couponCardType === 2 && !params.reduceCost) || 
          (params.couponCardType === 3 && (!params.discount || !params.maxCost)) || 
          (params.couponCardType === 1 && (!params.exchangeNumber || !params.maxCost))) {
          callback(new Error('请填写优惠信息'))
        }else{
          let resg = /.*\..*/   
          if (resg.test(String(params.leastCost)) && String(params.leastCost).split(".")[1].length > 2 || 
              resg.test(String(params.reduceCost)) && String(params.reduceCost).split(".")[1].length > 2 || 
              resg.test(String(params.maxCost)) && String(params.maxCost).split(".")[1].length > 2) {
            callback(new Error('金额只能填写整数或两位小数'))
          }
          if (params.couponCardType === 3 && String(params.discount).indexOf(".") && String(params.discount).length > 3) {
            callback(new Error('折扣只能填写整数或一位小数'))
          }
          if (params.couponCardType === 1 && (resg.test(String(params.exchangeNumber)) || Number(params.exchangeNumber) % 1 !== 0)) {
            callback(new Error('房晚只能填写整数'))
          }
          callback()
        }
      },
      totalQuantity: (rule,value,callback) =>{
        if (!this.addEditParams.totalQuantity) {
          callback(new Error('请设置优惠券总库存'))
        }else{
          callback()
        }
      },
      promoCode: (rule,value,callback) =>{
        if (!this.addEditParams.promoCode) {
          callback(new Error('请自定义一个领取码'))
        }else{
          if (blankRegExp.test(this.addEditParams.promoCode)) {
            callback(new Error('通用码不可使用空格'))
          }else{
            callback()
          }
        }
      },
      totalInventory: (rule,value,callback) =>{
        if (!this.quantity.totalInventory) {
          callback(new Error('请输入调整的总库存'))
        }else{
          if (this.addEditParams.collectType === 1 && this.addEditParams.promoCodeType === 1 ){
            if(Number(this.quantity.totalInventory) < Number(this.addEditParams.totalQuantity)) {
              callback(new Error('必须大于原总库存'))
              return
            }
            if(Number(this.quantity.totalInventory) > 10000) {
              callback(new Error('一卡一码最高库存为10000，请调整设置'))
              return
            }
            
          } else if (Number(this.quantity.totalInventory) < this.addEditParams.quantity) {
            callback(new Error('必须大于等于已领取数量'))
            return
          }
          callback()
        }
      },
      latestCollectDate: (rule,value,callback) =>{
        if (!this.addEditParams.latestCollectDate) {
          callback(new Error('请选择最后领取日期'))
        }else{
          callback()
        }
      },
    }

    return {
      // 检验规则
      editViewRules: {
        title: [{ required: true, validator: validateAtity.title, trigger: 'blur' }],
        description: [{ required:true, validator:validateAtity.description, trigger:'blur'}],
        fixedTime: [{ required:true, validator:validateAtity.fixedTime}],
        selChainId: [{ validator:validateAtity.selChainId, trigger:'change'}],
        selCityId: [{ validator:validateAtity.selCityId, trigger:'change'}],
        joinDate: [{ required:true, validator:validateAtity.joinDate, trigger:'change'}],
        week: [{ required:true, validator:validateAtity.week}],
        discountPrice: [{ required:true, validator:validateAtity.discountPrice, trigger:'blur'}],
        totalQuantity: [{ required:true, validator:validateAtity.totalQuantity, trigger:'blur'}],
        promoCode: [{ required:true, validator:validateAtity.promoCode, trigger:'blur'}],
        totalInventory: [{ required:true, validator:validateAtity.totalInventory, trigger:'blur'}],
        latestCollectDate: [{ required:true, validator:validateAtity.latestCollectDate, trigger:'change'}],
      },
      productionSetting: false, // 活动产品限制弹窗
      orderSetting: false, // 订单限制弹窗
      quantitySetting: false, // 调整库存弹窗
      columns: [
        {
          title: 'id',
          key: 'chainId',
          align: "center",
          width: 80
        },
        {
          title: '门店名',
          key: 'chainName',
          align: "center",
          width: 180
        },
        {
          title: '省市区',
          align: "center",
          width: 140,
          render: (h, params) => {
            let address = params.row.chainAddress ? params.row.chainAddress : `${params.row.province} ${params.row.city} ${params.row.district}`
            return h('span', {}, address)
          }
        },
        {
          title: '操作',
          align: "center",
          width: 78,
          render: (h, params) => {
            return h('span',{
              style: {
                color: '#2d8cf0',
                cursor: 'pointer'
              },
              on:{
                click:()=>{
                  this.removeChain(params.row.chainId)
                }
              }
            }, '删除')
          }
        },
      ],
      chainParams: {
        chainCount: 0,
        pageNum: 1,
        selChainsArr: []
      },
      allChains: [], // 所有的门店数据
      allCities: [], // 所有城市数据
      selChainParam: {
        selChainId: ''
      },
      selCityParam: {
        selCityId: ''
      },
      selChainOption: {},
      selCities: {},
      topTitle: '新增优惠券',
      prodText: '无限制',
      orderText: '无限制',
      editable: true, // 是否可编辑

      addEditParams: {
        id: '', // 优惠券id
        promoCodeType: 2, // 优惠码类型。1-一卡一码；2-通用码
        collectType: 1, // 优惠券领取类型，1劵码领取，2系统下发
        beginTimestamp: '', // 优惠券有效开始时间
        endTimestamp: '', // 优惠券有效结束时间
        couponCardType: 2, // 优惠类型：1兑换券, 2代金券, 3折扣券
        reduceCost: null, // 代金券专用，表示减免金额（单位为分)
        bearParty: 2, // 优惠成本：1-Xbed承担；2-业主承担
        type: 1, // 使用时间的类型。DATE_TYPE_FIX_TIME_RANGE 表示固定日期区间，DATE_TYPE_FIX_TERM表示固定时长（自领取后按天算）
        productRestrictType: 0, // 产品限制类型，0无限制，1城市，2门店
        orderRestrictType: 0, // 订单限制类型，0无限制，1入离日期，2订单类型
        restrictBeginTimestamp: '', // 订单限制开始日期
        restrictEndTimestamp: '', // 订单限制结束日期
        restrictWeek: '', // 订单限制周时间
        productRestricts: [], // 产品限制数据
        orderRestricts: [], // 订单限制数据
        description: '', // 对客简介
        totalQuantity: null, // 总库存
        title: '', // 优惠券名称
        promoCode: '', // 通用码
        fixedTerm: null, // 表示自领取后多少天内有效，领取后当天有效填写1
        leastCost: null, // 表示起用金额（单位为分)
        exchangeNumber: null, // 兑换劵专用，兑换数量（单位房晚）
        maxCost: null, // 优惠上限（单位为分)
        discount: null, // 折扣券专用字段, 表示打折额度(百分比)
        latestCollectDate: Moment().add(90, 'd').format( 'YYYY-MM-DD'), // 最后领取日
      },
      cardId: '', // 优惠券ID
      fixedTime: [], // 优惠券有效日期
      promoTips: ['', '预订时原价大于等于设置金额，可减免房费由低到高的日期房费；设置全单最高减免金额，需支付减房费晚数合计金额超出部分', '预订时原价大于等于设置金额，可减免设置金额，设置减免金额大于原价时，最多减至应付为0', '预订时原价大于等于设置金额，可全单按折扣优惠；设置全单最高减免金额，需支付折扣金额超出部分'],
      prodLimit: {   // 参与产品设置
        type: '', // 已选择的类型
        city: [], // 参与城市
        chains: [] // 剔除/选择门店
      },
      orderLimit: {   // 参与订单设置
        joinDate: [], // 参与时间
        week: ['0','1','2','3','4','5','6'],
        noJoinDate: []
      },
      clickAddChain: false, // 点击添加门店
      clickAddCity: false, // 点击添加城市
      quantity: {
        totalInventory: null, // 调整总库存
        cacheQuantity: null, // 缓存调整的库存
        maxQuantity: 10000, // 最大总库存
      },
      addLoading: false, // 新增/编辑按钮
      dateOptions: { // 昨日之前的日期不可选
        disabledDate (current) {
          let tomorrow = Moment().add(-1, 'day').startOf('day').valueOf()
          return current && current.valueOf() < tomorrow
        }
      },
    }
  },
  async mounted() {
    this.$Notice.config( {
			top: 200
		} );
    if (this.addEditParams.id) {
      this.topTitle = '编辑优惠券'
      this.editable = false
      this.editActivity()
    } else {
      localStorage.removeItem("promoProd")
      localStorage.removeItem("promoOrder")
    }
    this.chainPage()
  },
  methods: {
    // 设置条件弹窗
    settingPops (type) {
      this[type] = true
      if (type === 'productionSetting') {
        let promoProd = JSON.parse(localStorage.getItem("promoProd"))
        if (promoProd) {
          this.addEditParams.productRestrictType = promoProd.type
          this.prodLimit = promoProd
          if (promoProd.chains.length > 0) this.chainParams.chainCount = promoProd.chains.length
        } else {
          this.chainParams.chainCount = 0
        }
        this.chainParams.pageNum = 1
        if (this.allChains && !this.allChains.length) this.getChainData()
        if (this.allCities && !this.allCities.length) this.getCityData()
        this.chainPage()
      }
      if (type === 'orderSetting') {
        let promoOrder = JSON.parse(localStorage.getItem("promoOrder"))
        if (promoOrder) {
          this.addEditParams.orderRestrictType = 1
          this.orderLimit = promoOrder
        } else {
          this.addEditParams.orderRestrictType = 0
          this.initieOrder()
        }
      }
      if (type === 'quantitySetting') {
        this.quantity.totalInventory = this.quantity.cacheQuantity
      }
    },

    // 获取优惠券详情
    async editActivity(){
      if (this.protHeaders.isForm) delete this.protHeaders["isForm"]
      let resp = (await API.omsAPI[this.env].clientServer.getPromoCardDetail({id: this.addEditParams.id}, this.protHeaders)).data;
      if ( resp.retCode ) {
        this.$Notice.error({
          title: '获取页面数据失败',
          desc: resp.msg
        })
        return
      }

      Object.assign(this.addEditParams, resp);
      this.addEditParams.type = resp.type == 'DATE_TYPE_FIX_TIME_RANGE' ? 1 : 2
      this.cardId = resp.cardId
      this.quantity.cacheQuantity = resp.totalQuantity
      if (resp.type === 'DATE_TYPE_FIX_TIME_RANGE') this.fixedTime = [Moment(resp.beginTimestamp).format( 'YYYY-MM-DD HH:mm'),Moment(resp.endTimestamp).format( 'YYYY-MM-DD 23:59')]
      this.initPrice(this.addEditParams)
      this.quantity.maxQuantity = this.addEditParams.collectType === 1 && this.addEditParams.promoCodeType === 1 ? 10000 : 99999999
      this.prodText = ['无限制', '城市', '门店'][resp.productRestrictType]

      // 限制产品
      if (resp.productRestrictType || (resp.productRestricts && resp.productRestricts.length)) {
        this.prodLimit.city = []
        this.prodLimit.chains = []
        this.prodLimit.type = resp.productRestrictType
        resp.productRestricts.map(item => {
          if (item.productType === 1) {
            this.prodLimit.city.push(item.cityName)
          }
          if (item.productType === 2 || item.productType === 3) {
            let chain = {}
            chain.chainId = item.chainId
            chain.chainName = item.chainName
            chain.chainAddress = item.chainAddress
            this.prodLimit.chains.push(chain)
          }
        })
        if (resp.productRestrictType === 0 && this.prodLimit.chains.length) this.prodText = '无限制（剔除部分门店）'
        if (resp.productRestrictType === 1 && this.prodLimit.chains.length) this.prodText = '无限制（剔除部分门店）'
        localStorage.setItem('promoProd', JSON.stringify(this.prodLimit))
      } else {
        localStorage.removeItem("promoProd")
      }

      // 限制订单
      if (resp.orderRestrictType) {
        this.orderLimit.joinDate = [Moment(resp.restrictBeginTimestamp).format( 'YYYY-MM-DD HH:mm'), Moment(resp.restrictEndTimestamp).format( 'YYYY-MM-DD HH:mm')]
        this.orderLimit.week = resp.restrictWeek.split(',')
        this.orderLimit.noJoinDate = []
        resp.orderRestricts.length && resp.orderRestricts.map((item, index) => {
          let noJoin = {}
          noJoin.count = index
          noJoin.date = [Moment(item.restrictBeginDate).format( 'YYYY-MM-DD HH:mm'), Moment(item.restrictEndDate).format( 'YYYY-MM-DD HH:mm')]
          this.orderLimit.noJoinDate.push(noJoin)
        })
        if (resp.orderRestrictType === 1) this.orderText = '入离日期'
        localStorage.setItem('promoOrder', JSON.stringify(this.orderLimit))
      } else {
        localStorage.removeItem("promoOrder")
      }
    },

    // 确定新增/保存编辑
    async saveInfo(){
      // 表单验证
      if(!this.handleValidator('editViewForm')) return
      let params = this.addEditParams
      let editParams = {}

      params.beginTimestamp = params.type === 1 ? Moment(this.fixedTime[0]).format( 'YYYY-MM-DD HH:mm:ss') : ''
      params.endTimestamp = params.type === 1 ? Moment(this.fixedTime[1]).format( 'YYYY-MM-DD 23:59:59') : ''
      if (params.type === 1) params.fixedTerm = null
      if (params.id) params.totalQuantity = Number(this.quantity.cacheQuantity)
      if (params.collectType === 2) params.promoCodeType = 1
      if (params.latestCollectDate) params.latestCollectDate = Moment(params.latestCollectDate).format( 'YYYY-MM-DD')

      params.createdUserId = Number(this.userid)
      params.type = params.type == 1 ? 'DATE_TYPE_FIX_TIME_RANGE' : 'DATE_TYPE_FIX_TERM'
      params.productRestricts = []
      params.orderRestricts = []
      
      // 拼接产品限制参数
      let prodLimit = JSON.parse(localStorage.getItem("promoProd"))
      if (prodLimit) {
        let productRestricts = []
        if (prodLimit.city.length) {
          prodLimit.city.map(item => {
            let prodCity = {}
            prodCity.productType = 1
            prodCity.cityName = item
            productRestricts.push(prodCity)
          })
        }
        if (prodLimit.chains.length){
          prodLimit.chains.map(item => {
            let prodChain = {}
            prodChain.productType = params.productRestrictType === 2 ? 2 : 3
            prodChain.chainId = item.chainId
            prodChain.chainName = item.chainName
            prodChain.chainAddress = item.chainAddress ? item.chainAddress : `${item.province}${item.city}${item.district}`
            productRestricts.push(prodChain)
          })
        }
        params.productRestricts = productRestricts
      }
      // else {
      //   params.productRestricts = []
      // }

      // 拼接订单限制参数
      let orderLimit = JSON.parse(localStorage.getItem("promoOrder"))
      if (orderLimit && params.orderRestrictType === 1) {
        params.restrictBeginTimestamp = Moment(orderLimit.joinDate[0]).format( 'YYYY-MM-DD')
        params.restrictEndTimestamp = Moment(orderLimit.joinDate[1]).format( 'YYYY-MM-DD')
        params.restrictWeek = orderLimit.week.join(',')
        if (orderLimit.noJoinDate.length) {
          let orderRestricts = []
          orderLimit.noJoinDate.map(item => {
            let noJoin = {}
            noJoin.restrictBeginDate = Moment(item.date[0]).format( 'YYYY-MM-DD')
            noJoin.restrictEndDate = Moment(item.date[1]).format( 'YYYY-MM-DD')
            orderRestricts.push(noJoin)
          })
          params.orderRestricts = orderRestricts
        }
      } else {
        params.restrictBeginTimestamp = ''
        params.restrictEndTimestamp = ''
        params.restrictWeek = ''
        // params.orderRestricts = []
      }

      // 过滤空字段
      params = Object.keys(params).reduce(function(c, k) {
        if (params[k] || (params[k] && params[k].length > 0) || params[k] === 0) {
          if (k === 'leastCost' || k === 'reduceCost' || k === 'maxCost') {
            c[k] = Number((params[k] * 100).toFixed(0))
          } else if (k === 'discount') {
            c[k] = Number((params[k] * 10).toFixed(0))
          } else {
            c[k] = params[k]
          }
        }
        return c
      }, {})

      // 编辑的接口不需要传以下参数
      if (params.id) {
        editParams = Object.assign(params, {
          promoCodeType: '',
          collectType: '',
          couponCardType: '',
          bearParty: '',
          type: '',
          reduceCost: null,
          promoCode: '',
          leastCost: null,
          exchangeNumber: null,
          maxCost: null,
          discount: null,
          quantity: ''
        })
        // 过滤空字段
        editParams = Object.keys(editParams).reduce(function(c, k) {
          if (editParams[k] || (editParams[k] && editParams[k].length > 0) || editParams[k] === 0) {
            c[k] = editParams[k]
          }
          return c
        }, {})
      }

      try {
        let resp
        this.protHeaders.isForm = true
        this.addLoading = true
        if (params.id) {
          resp = (await API.omsAPI[this.env].clientServer.editPromoCode(editParams, this.protHeaders)).data;
        } else {
          resp = (await API.omsAPI[this.env].clientServer.addPromoCode(params, this.protHeaders)).data;
        }
        this.addLoading = false

        if ( resp.retCode ) {
          this.$Notice.error({
            title: params.id ? '优惠券编辑失败' : '优惠券新增失败',
            desc: resp.msg
          })
          this.addEditParams.type = this.addEditParams.type == 'DATE_TYPE_FIX_TIME_RANGE' ? 1 : 2
          this.initPrice(params)
          return
        }
        this.$Notice.success({
          title: params.id ? '优惠券编辑成功' : '优惠券新增成功',
        })
        if (!params.id) this.topTitle = '编辑优惠券'
        // this.addEditParams.type = params.type == 'DATE_TYPE_FIX_TIME_RANGE' ? 1 : 2
        this.addEditParams.id = resp
        localStorage.setItem("promoCode", resp)
        this.editable = false
        this.editActivity()
      } catch (e) {
        this.$Notice.error({
          title: '服务器出错，请稍后再试'
        })
        this.addLoading = false
        this.addEditParams.type = this.addEditParams.type == 'DATE_TYPE_FIX_TIME_RANGE' ? 1 : 2
        this.initPrice(params)
      }
    },

    // 保存失败要还原金额框的参数
    initPrice(params) {
      if (params.leastCost) this.addEditParams.leastCost = params.leastCost / 100
      if (params.reduceCost) this.addEditParams.reduceCost = params.reduceCost / 100
      if (params.maxCost) this.addEditParams.maxCost = params.maxCost / 100
      if (params.discount) this.addEditParams.discount = params.discount / 10
    },

    // 表单验证
    handleValidator(formName) {
      let validatorResult = false
      this.$refs[formName].validate((valid) =>{
        validatorResult = valid
      })
      return validatorResult
    },

    /************   设置参与产品限制 begin   ***************/
    // 获取所有门店数据
    async getChainData () {
      const resp = (await API.omsAPI[this.env].cleaner.queryChainListForCleanOrder(this.token)).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: "获取门店列表失败",
          desc: resp.msg
        });
        return
      }
      this.allChains = resp;
      // if (this.addEditParams.id) {
      //   this.editActivity()
      // }
    },
    // 获取所有城市
    async getCityData () {
      let resp = (await API.omsAPI[this.env].php.queryAllCities()).data.data;
      this.allCities = resp;
    },
    // 已选择的门店分页
    changePage(pageIndex) {
      this.chainParams.pageNum = pageIndex
      this.chainPage()
    },
    // 下拉选择的门店
    selectChain (options) {
      if (!options) return
      this.allChains.map(item => {
        if (item.chainId === options) {
          this.selChainOption = item
          return
        }
      })
    },
    // 门店列表只显示5条数据，分页显示
    chainPage () {
      let currpage = this.chainParams.pageNum
      this.chainParams.selChainsArr = this.prodLimit.chains.slice(Number(currpage * 5 - 5), Number(currpage * 5))
    },
    // 添加选择的门店
    addChains () {
      // 选择框验证
      this.clickAddCity = false
      this.clickAddChain = true
      if(!this.handleValidator('productionForm')) return
      
      this.prodLimit.chains.unshift(this.selChainOption)
      this.chainParams.chainCount++
      this.selChainOption = {}
      this.chainPage()
      this.cancelModal('resetChain', 'productionForm', true)
    },    
    // 删除单个门店
    removeChain(chainId) {
      this.prodLimit.chains.map((item, index) => {
        if (item.chainId === chainId) {
          this.prodLimit.chains.splice(index, 1)
        }
      })
      this.chainParams.chainCount--
      if (!Math.ceil(this.chainParams.chainCount % 5)) this.chainParams.pageNum = 1
      this.chainPage()
    },
    // 选择城市
    selectCity(options) {
      if (!options) return
      this.allCities.map(item => {
        if (item === options) {
          this.selCities = item
          return
        }
      })
    },
    // 添加城市
    addCities() {
      this.clickAddChain = false
      this.clickAddCity = true
      if(!this.handleValidator('productionForm')) return

      this.prodLimit.city.unshift(this.selCities)
      this.$refs.resetCity.clearSingleSelect()
      this.$refs.productionForm.resetFields()
    },
    // 删除已添加的城市
    deleteCity(event, index) {
      this.prodLimit.city.splice(index, 1)
    },
    // 选择类型
    changeProRadio(type) {
      this.$refs.resetChain.clearSingleSelect()
      this.$refs.productionForm.resetFields()
      this.clickAddChain = false
      this.clickAddCity = false
      console.log(this.addEditParams.productRestrictType, 'type', type)
      let promoProd = JSON.parse(localStorage.getItem('promoProd'))
      if (promoProd && type == promoProd.type) {
        this.prodLimit = promoProd
        this.chainParams.chainCount = promoProd.chains.length ? promoProd.chains.length : 0
      } else {
        this.prodLimit.city = []
        this.prodLimit.chains = []
        this.chainParams.chainCount = 0
      }
      this.chainParams.pageNum = 1
      this.chainPage()
    },
    // 确定按钮事件
    handleProdOk() {
      this.$refs.prodModal.buttonLoading = false;
      let editParam = this.addEditParams.productRestrictType
      if (editParam === 2) this.clickAddChain = true
      if (editParam === 1) this.clickAddCity = true
      if(!this.handleValidator('productionForm')) return
      if (editParam === 2 && !this.prodLimit.chains.length) {
        this.$Notice.error({
          title: '请添加门店'
        })
        return
      }
      if (editParam === 1 && !this.prodLimit.city.length) {
        this.$Notice.error({
          title: '请添加城市'
        })
        return
      }

      this.productionSetting = false
      if (editParam || this.prodLimit.chains.length) { 
        this.prodLimit.type = editParam
        localStorage.setItem('promoProd', JSON.stringify(this.prodLimit)) 
      } else {
        localStorage.removeItem("promoProd")
      }  
      this.prodText = ['无限制', '城市', '门店'][editParam]
      if (editParam === 0 && this.prodLimit.chains.length) this.prodText = '无限制（剔除部分门店）'
      if (editParam === 1 && this.prodLimit.chains.length) this.prodText = '城市（剔除部分门店）'
      this.cancelModal('resetChain', 'productionForm')
    },
    /************   设置活动产品限制 end   ***************/

    /************   设置订单限制 begin   ***************/
    handleOrderOk() {
      this.$refs.orderModal.buttonLoading = false;
      if(!this.handleValidator('orderForm')) return
      if (this.addEditParams.orderRestrictType) {
        if (this.checkNoJoin()) return
        localStorage.setItem('promoOrder', JSON.stringify(this.orderLimit))

      } else {
        this.initieOrder()
        localStorage.removeItem("promoOrder")
      }
      this.orderSetting = false
      this.orderText = ['无限制', '入离日期'][this.addEditParams.orderRestrictType]
      this.$refs.orderForm.resetFields()
    },
    // 验证不参与房晚
    checkNoJoin() {
      let resp = false
      if (this.orderLimit.noJoinDate.length) {
        for (let i in this.orderLimit.noJoinDate) {
          if (this.orderLimit.noJoinDate[i].date && !this.orderLimit.noJoinDate[i].date[0]) {
            this.$Notice.error({
              title: "不参与房晚日期不能为空"
            });
            resp = true
            break;
          }
        }
      }
      return resp
    },
    cancelOrderModal() {
      let rentArr = JSON.parse(localStorage.getItem('promoOrder'))
      if (this.addEditParams.orderRestrictType && !rentArr) {
        this.addEditParams.orderRestrictType = 0
        this.initieOrder()
      }
    },
    // 初始化参与订单的值
    initieOrder() {
      this.orderLimit = {
        joinDate: [],
        week: ['0','1','2','3','4','5','6'],
        noJoinDate: []
      }
    },
    // 添加不参与房晚设置
    addNoJoinRoom() {
      if (this.orderLimit.joinDate && !this.orderLimit.joinDate[0]) {
        this.$Notice.error({
          title: "请先选择可用的房晚日期"
        })
        return
      }
      if (this.orderLimit.noJoinDate.length === 20) {
        this.$Notice.error({
          title: "最多添加20段"
        })
        return
      }
      this.orderLimit.noJoinDate.push({count: this.orderLimit.noJoinDate.length, date: []})
    },
    // 删除不参与房晚设置
    deleteDate(index) {
      this.orderLimit.noJoinDate.splice(index, 1)
    },
    /************   设置订单限制 end   ***************/

    // 关闭 产品 限制弹窗
    cancelModal(resetName, formName, isAdd) {
      if (this.productionSetting) {
        this.$refs[resetName].clearSingleSelect()
      }
      this.$refs[formName].resetFields()
      this.clickAddChain = false
      this.clickAddCity = false

      if (!isAdd && formName === 'productionForm') {
        let prod = JSON.parse(localStorage.getItem('promoProd'))
        if (this.addEditParams.productRestrictType && !prod) {
          this.prodLimit = {
            city: [], // 参与城市
            chains: [] // 剔除/选择门店
          }
          this.addEditParams.productRestrictType = 0
        }
      }
    },

    // 选择活动起止时间
    changeDate() {
      this.fixedTime = [
        Moment(this.fixedTime[0]).format( 'YYYY-MM-DD HH:mm'),
        Moment(this.fixedTime[1]).format( 'YYYY-MM-DD 23:59')
      ]
    },

    // 选择可用房晚时间范围
    changeJoinDate() {
      this.orderLimit.joinDate = this.orderLimit.joinDate[0] ? [
        Moment(this.orderLimit.joinDate[0]).format( 'YYYY-MM-DD'),
        Moment(this.orderLimit.joinDate[1]).format( 'YYYY-MM-DD')
      ] : []
    },

    // 选择不可用房晚时间范围
    changeNoJoinDate(count) {
      this.orderLimit.noJoinDate.map((item, index) => {
        if (count === index) {
          item.date = item.date[0] ? [
            Moment(item.date[0]).format( 'YYYY-MM-DD'),
            Moment(item.date[1]).format( 'YYYY-MM-DD')
          ] : []
        }
      })
    },

    // 编辑按钮
    editInfo() {
      if (!this.editable) {
        this.editable = true
      } else {
        this.saveInfo()
      }
    },

    // 调整总库存
    handleQuantityOk() {
      this.$refs.quantityModal.buttonLoading = false;
      if(!this.handleValidator('quantityForm')) return
      this.quantitySetting = false
      this.quantity.cacheQuantity = this.quantity.totalInventory
    },

  }
}
</script>

<style lang="scss">
.sel-tag {
  border: 1px solid #ddd;
  border-radius: 5px;
  height: 120px;
  overflow-y: auto;
  margin-right: 7px;
  padding-bottom: 10px;
  .tags {
    margin: 10px 0 0 10px;
    height: 26px;
    line-height: 26px;
  }
}
.tips-p {
  color: red;
  margin-bottom: 12px;
  margin-left: 83px;
}
.input-unit {
  display: inline-block;
  position: relative;
  margin-left: 9px;
  .input {
    width: 150px;
    margin-left: 4px;
  }
  .unit {
    color: #999;
    position: absolute;
    right: 25px;
    top: 1px;
    line-height: 34px;
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/marketing/promoCodeEdit.vue